<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div class="input_radio_container">
    <input v-model="value" type="radio" v-bind="$attrs" />
  </div>
</template>

<style lang="scss" scoped>
.input_radio_container {
  @apply flex justify-center items-center relative;
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--white-main);
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  color: var(--text-secondary-color);
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  border: 1px solid currentColor;
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--primary-blue-color);
  }

  &:checked::before {
    transform: scale(1);
  }

  &:checked {
    color: var(--primary-blue-color);
  }

  &:disabled::before {
    box-shadow: inset 1em 1em var(--grey-medium-light);
    cursor: default;
  }

  &:disabled {
    color: var(--grey-medium-light);
    cursor: default;
  }

  &:not([disabled]) {
    &:hover,
    &:focus {
      @apply cursor-pointer;
      color: var(--primary-blue-color);
    }
  }
}
</style>
